import $ from 'jquery'; 
import 'bootstrap';
window.$ = window.jQuery = $;
import Alpine from 'alpinejs';
import Swal from 'sweetalert2';

window.Alpine = Alpine;

Alpine.start();
import '../js/order.js';
import '../js/select2.min.js';
import '../js/bootstrap.js';
import '../js/jquery.js';
import '../js/vendor.js';
import '../js/data-table.js';

